import { computed } from 'vue';
import { useConfig } from 'dashboard/composables/useConfig';
import { useMapGetter } from 'dashboard/composables/store';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

// Single source of truth for whether Copilot can be shown at all, shared by
// the floating launcher and the panel so their visibility conditions can
// never drift apart (previously each recomputed this independently, and the
// panel had extra gates the launcher didn't — see useCopilotAvailability
// usage sites for the bug this fixes).
export function useCopilotAvailability() {
  const { isEnterprise } = useConfig();
  const currentAccountId = useMapGetter('getCurrentAccountId');
  const isFeatureEnabledonAccount = useMapGetter(
    'accounts/isFeatureEnabledonAccount'
  );

  const isCopilotAvailable = computed(() => {
    if (!isEnterprise) return false;
    return isFeatureEnabledonAccount.value(
      currentAccountId.value,
      FEATURE_FLAGS.CAPTAIN
    );
  });

  return { isCopilotAvailable };
}
